export var NotebookSessionStatus;
(function (NotebookSessionStatus) {
    NotebookSessionStatus["NOTEBOOK_SESSION_STATUS_STARTING"] = "STARTING";
    NotebookSessionStatus["NOTEBOOK_SESSION_STATUS_ACTIVE"] = "ACTIVE";
    NotebookSessionStatus["NOTEBOOK_SESSION_STATUS_STOPPING"] = "STOPPING";
    NotebookSessionStatus["NOTEBOOK_SESSION_STATUS_STOPPED"] = "STOPPED";
    NotebookSessionStatus["NOTEBOOK_SESSION_STATUS_FAILED"] = "FAILED";
})(NotebookSessionStatus || (NotebookSessionStatus = {}));
